import { Star } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const StarIcon = createLucideIcon(Star);
